import { Currency, ProductType } from '../../constants';

export type CartImageResponse = {
  id: number;
  src: string;
  thumbnail: string;
};

export type CartItemResponse = {
  key: string;
  productId: number;
  brand: string;
  sku: string;
  quantity: number;
  quantityLimit?: {
    min: number;
    max: number;
  };
  type: ProductType;
  name: string;
  productLink: string;
  image: CartImageResponse[];
  itemData?: {
    size?: string;
    pack?: string;
  };
  price: {
    price: number;
    regularPrice: number;
    salePrice: number;
  };
};

export type CartCouponResponse = {
  code: string;
  discount: number;
  discountType: 'percent';
  discountTax: number;
};

export type CartShippingRateResponse = {
  rateId: string;
  name: string;
  price: number;
  taxes: number;
};

export type CartResponseResponse = {
  cart: {
    item: CartItemResponse[];
    totals: {
      totalPrice: number;
      totalTax: number;
      totalDiscount: number;
      totalDiscountTax: number;
      // tax value
      totalCustom: number;
      total: number;
    };
    currency: {
      currency: Currency;
      currencySymbol: string;
      isCurrencyPrefixed: boolean;
    };
    coupons: CartCouponResponse[];
    shippingRates: CartShippingRateResponse[];
  };
  isAuthenticated: boolean;
  cartInfo: {
    cartToken: string;
    itemsInCart: number;
  };
  generatedSessionKey?: { key: string; value: string };
};
